(function ($) {
    $(document).ready(function () {

        $(".hamburger_menu").on("click", function (e) {
            e.preventDefault();
            $(".slide-bar").toggleClass("show");
            $("body").addClass("on-side");
            $('.body-overlay').addClass('active');
            $(this).addClass('active');
        });

        $(".close-mobile-menu > a").on("click", function (e) {
            e.preventDefault();
            $(".slide-bar").removeClass("show");
            $("body").removeClass("on-side");
            $('.body-overlay').removeClass('active');
            $('.hamburger_menu').removeClass('active');
        });


        {
            function animateElements() {
                $('.progressbar').each(function () {
                    var elementPos = $(this).offset().top;
                    var topOfWindow = $(window).scrollTop();
                    var percent = $(this).find('.circle').attr('data-percent');
                    var percentage = parseInt(percent, 10) / parseInt(100, 10);
                    var animate = $(this).data('animate');
                    if (elementPos < topOfWindow + $(window).height() - 10 && !animate) {
                        $(this).data('animate', true);
                        $(this).find('.circle').circleProgress({
                            startAngle: -Math.PI / 2,
                            value: percent / 100,
                            size: 180,
                            thickness: 10,
                            emptyFill: "#fff",
                            fill: {
                                color: '#49A6FF'
                            }
                        }).on('circle-animation-progress', function (event, progress, stepValue) {
                            $(this).find('div').text((stepValue * 100).toFixed() + "%");
                        }).stop();
                    }
                });
            }

            // Show animated elements
            animateElements();
            $(window).scroll(animateElements);
        }
        ;
        // sticky header active
        if ($("#header").length > 0) {
            $(window).on("scroll", function (event) {
                var scroll = $(window).scrollTop();
                if (scroll < 1) {
                    $("#header").removeClass("sticky");
                } else {
                    $("#header").addClass("sticky");
                }
            });
        }

        //Aos animation active
        AOS.init({
            offset: 100,
            duration: 400,
            easing: "ease-in-out",
            anchorPlacement: "top-bottom",
            disable: "mobile",
            once: false,
        });


        //Video poppup
        if ($(".play-btn").length > 0) {
            $(".play-btn").magnificPopup({
                type: "iframe",
            });
        }
        ;

        // page-progress
        var progressPath = document.querySelector(".progress-wrap path");
        var pathLength = progressPath.getTotalLength();
        progressPath.style.transition = progressPath.style.WebkitTransition =
            "none";
        progressPath.style.strokeDasharray = pathLength + " " + pathLength;
        progressPath.style.strokeDashoffset = pathLength;
        progressPath.getBoundingClientRect();
        progressPath.style.transition = progressPath.style.WebkitTransition =
            "stroke-dashoffset 10ms linear";
        var updateProgress = function () {
            var scroll = $(window).scrollTop();
            var height = $(document).height() - $(window).height();
            var progress = pathLength - (scroll * pathLength) / height;
            progressPath.style.strokeDashoffset = progress;
        };
        updateProgress();
        $(window).scroll(updateProgress);
        var offset = 50;
        var duration = 550;
        jQuery(window).on("scroll", function () {
            if (jQuery(this).scrollTop() > offset) {
                jQuery(".progress-wrap").addClass("active-progress");
            } else {
                jQuery(".progress-wrap").removeClass("active-progress");
            }
        });
        jQuery(".progress-wrap").on("click", function (event) {
            event.preventDefault();
            jQuery("html, body").animate({scrollTop: 0}, duration);
            return false;
        });

        //product colors
        const colors = $(".accordion1 .accordion-item");
        colors.on("click", function () {
            $(".accordion1 .accordion-item").removeClass("active");
            $(this).addClass("active");
        });

        //tes1 active
        const tes1 = $(".controls li");
        tes1.on("click", function () {
            $(".controls li").removeClass("active");
            $(this).addClass("active");
        });

        $("#ce-toggle1").click(function (event) {
            $(".plan-toggle-wrap1").toggleClass("active");
        });

        $("#ce-toggle1").change(function () {
            if ($(this).is(":checked")) {
                $(".tab-content #yearly1").hide();
                $(".tab-content #monthly1").show();
            } else {
                $(".tab-content #yearly1").show();
                $(".tab-content #monthly1").hide();
            }
        });

        $(".case1-slider").slick({
            autoplay: true,
            autoplaySpeed: 1500,
            margin: "30",
            slidesToShow: 3,
            arrows: true,
            centerMode: false,
            loop: true,
            centerMode: false,
            prevArrow: $(".testimonial-prev-arrow1"),
            nextArrow: $(".testimonial-next-arrow1"),
            draggable: true,
            centerPadding: "40px",
            dots: false,
            scroll: true,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
            ],
        });


        $('.tes3-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            prevArrow: $(".testimonial3-prev-arrow"),
            nextArrow: $(".testimonial3-next-arrow"),
        });

        $('.tes7-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            asNavFor: '.iamge-slider',
            prevArrow: $(".testimonial7-prev-arrow"),
            nextArrow: $(".testimonial7-next-arrow"),
        });

        $('.iamge-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            asNavFor: '.tes7-slider',
            fade: true,
        });

        $('.team-logo-slider').owlCarousel({
            autoplay: true,
            autoplayTimeout: 1000,
            loop: true,
            margin: 10,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                600: {
                    items: 3,
                    nav: false
                },
                1000: {
                    items: 5,
                    nav: false,
                    loop: false
                }
            }
        });


    });


    //preloader
    $(window).on("load", function (event) {
        setTimeout(function () {
            $(".preloader").fadeToggle();
        }, 500);
    });

    /* Text Effect Animation */
    if ($('.text-anime-style-1').length) {
        let staggerAmount = 0.05,
            translateXValue = 0,
            delayValue = 0.5,
            animatedTextElements = document.querySelectorAll('.text-anime-style-1');

        animatedTextElements.forEach((element) => {
            let animationSplitText = new SplitText(element, {type: "chars, words"});
            gsap.from(animationSplitText.words, {
                duration: 1,
                delay: delayValue,
                x: 20,
                autoAlpha: 0,
                stagger: staggerAmount,
                scrollTrigger: {trigger: element, start: "top 85%"},
            });
        });
    }

    if ($('.text-anime-style-2').length) {
        let staggerAmount = 0.05,
            translateXValue = 20,
            delayValue = 0.5,
            easeType = "power2.out",
            animatedTextElements = document.querySelectorAll('.text-anime-style-2');

        animatedTextElements.forEach((element) => {
            let animationSplitText = new SplitText(element, {type: "chars, words"});
            gsap.from(animationSplitText.chars, {
                duration: 1,
                delay: delayValue,
                x: translateXValue,
                autoAlpha: 0,
                stagger: staggerAmount,
                ease: easeType,
                scrollTrigger: {trigger: element, start: "top 85%"},
            });
        });
    }

    if ($('.text-anime-style-3').length) {
        let animatedTextElements = document.querySelectorAll('.text-anime-style-3');

        animatedTextElements.forEach((element) => {
            //Reset if needed
            if (element.animation) {
                element.animation.progress(1).kill();
                element.split.revert();
            }

            element.split = new SplitText(element, {
                type: "lines,words,chars",
                linesClass: "split-line",
            });
            gsap.set(element, {perspective: 400});

            gsap.set(element.split.chars, {
                opacity: 0,
                x: "50",
            });

            element.animation = gsap.to(element.split.chars, {
                scrollTrigger: {trigger: element, start: "top 95%"},
                x: "0",
                y: "0",
                rotateX: "0",
                opacity: 1,
                duration: 1,
                ease: Back.easeOut,
                stagger: 0.02,
            });
        });
    }

    $('select').niceSelect();


})(jQuery);


function itemactive() {
    jQuery('.testimonial-carousel').on('slide.bs.carousel', function (evt) {
        jQuery('.testimonial-carousel .controls li.active').removeClass('active');
        jQuery('.testimonial-carousel .controls li:eq(' + $(evt.relatedTarget).index() + ')').addClass('active');
    })
};

jQuery(document).ready(function ($) {
    $('.customer-logos').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 3
            }
        }]
    });
    $('.ebook-preview').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        margin: 0,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" class="e-font-icon-svg e-eicon-chevron-left" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M646 125C629 125 613 133 604 142L308 442C296 454 292 471 292 487 292 504 296 521 308 533L604 854C617 867 629 875 646 875 663 875 679 871 692 858 704 846 713 829 713 812 713 796 708 779 692 767L438 487 692 225C700 217 708 204 708 187 708 171 704 154 692 142 675 129 663 125 646 125Z"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" class="e-font-icon-svg e-eicon-chevron-right" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M696 533C708 521 713 504 713 487 713 471 708 454 696 446L400 146C388 133 375 125 354 125 338 125 325 129 313 142 300 154 292 171 292 187 292 204 296 221 308 233L563 492 304 771C292 783 288 800 288 817 288 833 296 850 308 863 321 871 338 875 354 875 371 875 388 867 400 854L696 533Z"></path></svg></div>',
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });


    let question = document.querySelectorAll(".question");
    question.forEach(question => {
        question.addEventListener("click", event => {
            const active = document.querySelector(".question.active");
            if(active && active !== question ) {
                active.classList.toggle("active");
                active.nextElementSibling.style.maxHeight = 0;
            }
            question.classList.toggle("active");
            const answer = question.nextElementSibling;
            if(question.classList.contains("active")){
                answer.style.maxHeight = answer.scrollHeight + "px";
            } else {
                answer.style.maxHeight = 0;
            }
        })
    })

});